import { create } from 'zustand';
import { CsvUpdateRequest, CsvUpdateResponse } from '../../model/csvupadte_request';
import { createDI } from '../../context/di/di';
import { ApiError, useApi } from '../../api/api';

export type SpreadSheetAction = {
  update: (request: CsvUpdateRequest, forceUpdate?: boolean) => Promise<CsvUpdateResponse>
  updating: boolean;
};

const [Provider, use] = createDI<SpreadSheetAction>();
export { Provider as SpreadSheetProvider, use as useSpreadSheetStore };

export const defaultSpreadSheetStore = () => {
  const api = useApi();

  return create<SpreadSheetAction>((set) => {
    return {
      updating: false,
      update: async (request: CsvUpdateRequest, forceUpdate: boolean = false) => {
        set({ updating: true });
        try {
          const resp = await api.path('/api/csv').header({ 'X-Force-Update': forceUpdate ? 'true' : 'false' }).put(request);
          if (resp.isError) {
            throw new ApiError(resp);
          }
          return resp.data as CsvUpdateResponse;
        } finally {
          set({ updating: false });
        }
      },
    };
  });
};
